import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette, LARGE_MARGIN, MIDDLE_MARGIN } from '../../theme';

const useStyles = makeStyles(() =>
  createStyles({
    wrapper: {
      padding: `${LARGE_MARGIN}px 0`,
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
    },
    title: {
      marginBottom: MIDDLE_MARGIN,
    },
    description: {
      color: colorsPalette.gray,
      '& a': {
        fontWeight: 'bold',
        color: colorsPalette.white,
        '&:hover': {
          color: colorsPalette.blue,
        },
      },
    },
  }),
);

export default useStyles;
